export class MockActivatedRoute {
  root: object;
  snapshot = jasmine.createSpyObj(['data']);
}
